<ng-container *ngIf="cell.parseHtml">
    <sh-html-parser *ngIf="cell.wrapText; else noWrap" class="sh-wrap-text" [message]="cell.value" [title]="cell.tooltip ?? cell.value"></sh-html-parser>
</ng-container>

<ng-container *ngIf="!cell.parseHtml">
    <span *ngIf="cell.wrapText; else noWrap" class="sh-wrap-text" [ngClass]="{'-sh-disabled': cell.disabled}" [innerHtml]="cell.value"></span>
</ng-container>

<ng-template #noWrap>
    <sh-list-row-title [title]="cell.value" [minWidthInRem]="cell.minWidthInRem"></sh-list-row-title>
</ng-template>
